<template>
	<div class="index">
		<div class="main">
			<div class="top">
				<div class="logo">
					<div class="logo_img"><el-image :src="imgLogo" ></el-image></div>
					<div class="logo_name">西柚子投资</div>
				</div>
				<div class="menu">
					<el-radio-group v-model="menu_radio" size="small">
						<el-radio-button label="水浒"></el-radio-button>
<!--						<el-radio-button label="西游" disabled></el-radio-button>-->
<!--						<el-radio-button label="三国" disabled></el-radio-button>-->
<!--						<el-radio-button label="红楼" disabled></el-radio-button>-->
					</el-radio-group>
				</div>
			</div>
			<div class="shuihu">
				<el-image :src="imgShuiHu22" ></el-image>
				<el-image :src="imgShuiHu82" ></el-image>
				<el-image :src="imgShuiHu86" ></el-image>
			</div>
		</div>
		<div class="bottom">
			<div>版权所有 © {{curYear}} 深圳市西柚子投资有限公司</div>
			<div><a target="_blank" href="https://beian.miit.gov.cn" style="margin-left: 8px;">粤ICP备19086264号-2</a></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Index",
	data() {
		return{
			curYear: '',
			imgLogo: require('@/assets/img/logo.png'),
			menu_radio: '水浒',
			imgShuiHu1: require('@/assets/img/shuihu/1.jpg'),
			imgShuiHu22: require('@/assets/img/shuihu/22.jpg'),
			imgShuiHu82: require('@/assets/img/shuihu/82.jpg'),
			imgShuiHu86: require('@/assets/img/shuihu/86.jpg')
		}
	},
	methods: {},
	mounted() {
		let curDate = new Date();
		this.curYear = curDate.getFullYear();
	},
	updated() {}
}
</script>

<style>
	html{ width: 100%; height: 100%; }
	body { margin: 0; padding: 0; width: 100%; height: 100%; overflow: hidden; }
	::-webkit-scrollbar { width: 5px; height: 6px; }
	::-webkit-scrollbar-track { background-color: #ffffff; border-radius: 2px; }
	::-webkit-scrollbar-thumb { background-color: #73869c; border-radius: 2px; border: 1px solid #6d6d6d; }
</style>
<style scoped>
	a{ text-decoration: none; transition: all 0.3s linear; }
	.index{ width: 100%; height: 100%; background: #161823; }
	.main{ width: 100%; height: 100%; font-family: 'SiYuan-Light', sans-serif; }
	.top{ display: flex; flex-wrap: nowrap; justify-content: space-between; height: 60px; line-height: 60px; padding-top: 16px; }
	.logo{ display: flex; flex-wrap: wrap; height: 60px; line-height: 60px; align-items: center; }
	.logo_img{ width: 28px; height: 28px; margin-left: 16px; margin-top: 2px; }
	.logo_name{ font-size: 26px; color: #ef761f; margin-left: 10px; font-family: 'SiYuan-Medium', sans-serif; }
	.menu{ margin-right: 16px; }
	::v-deep .el-radio-group>.is-active .el-radio-button__inner{ background-color: #ef761f; border-color: #ef761f; }
	.bottom{ position: absolute; bottom: 0; color: #ef761f; font-size: 12px; width: 100%; background: #161823; padding: 5px 0; display: flex; justify-content: center; }
	.bottom a{ text-decoration: none; color: #ef761f; }
	.bottom a:hover{ color: #e0b494; }
	.shuihu{ display: flex; flex-wrap: nowrap; margin-top: 20px; opacity: 0.7; }
	.shuihu>el-image{ }
</style>